import { render } from "./TheCardClustersList.vue?vue&type=template&id=f044a3ca"
import script from "./TheCardClustersList.vue?vue&type=script&lang=js"
export * from "./TheCardClustersList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__